const VisionMissionSection = () => {
  return (
    <section className="flex w-full items-center justify-center bg-[#d9202d] py-16">
      <div className="max-w-[1280px] px-6 lg:px-16">
        {/* Vision */}
        <div className="mb-12 text-center">
          <h2 className="mb-6 pb-5 pt-5 font-['Poppins'] text-2xl font-bold text-white lg:text-3xl">
            Visi Kami
          </h2>
          <p className="border-b border-t border-white/35 py-5 font-['Poppins'] text-xl font-semibold leading-9 text-white lg:text-2xl">
            Menjadi jembatan karier global terbesar dan terpercaya yang
            memberdayakan talenta Indonesia untuk sukses bekerja dan berkembang
            di Jepang.
          </p>
        </div>

        {/* Mission */}
        <div className="text-center">
          <h2 className="mb-6 pb-5 pt-5 font-['Poppins'] text-2xl font-bold text-white lg:text-3xl">
            Misi Kami
          </h2>

          <div className="space-y-0">
            <p className="border-b border-t border-white/35 py-5 font-['Poppins'] text-xl font-normal leading-7 text-white lg:text-2xl">
              Mempersiapkan talenta dengan pelatihan bahasa, skill, dan mindset
              global.
            </p>

            <p className="border-b border-t border-white/35 py-5 font-['Poppins'] text-xl font-normal leading-7 text-white lg:text-2xl">
              Menghubungkan talenta unggul dengan perusahaan Jepang yang tepat
              dan tepercaya.
            </p>

            <p className="border-b border-t border-white/35 py-5 font-['Poppins'] text-xl font-normal leading-7 text-white lg:text-2xl">
              Membuka akses kerja profesional di Jepang untuk semua talenta
              Indonesia.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VisionMissionSection
